import React from 'react';

import { PATH } from 'src/pages/pdfRegistration';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import { SCREENS } from 'src/constants/screens';

const PDFRegistrationRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/pdfRegistration')),
        title: t('menu_home.pdf_registration'),
        screenId: SCREENS.R1510,
      },
    ],
  },
];

export default PDFRegistrationRoute;
